/** @jsx jsx */
import { jsx, Box } from 'theme-ui';
import SlickSlider from 'react-slick';
import styles from './styles';
import theme from '../../gatsby-plugin-theme-ui-v1';

const Slider = ({
  slidesToShow,
  slidesToScroll,
  showDots,
  infinite,
  children,
  backgroundColor,
  backgroundColorOverride,
  sectionSize,
  showArrows,
}) => {
  return (
    <Box
      sx={{
        bg: backgroundColorOverride || backgroundColor,
      }}
    >
      <Box
        sx={{
          height: sectionSize === 'viewHeight100' ? sectionSize : 'auto',
          mx: 'auto',
          py: sectionSize === 'viewHeight100' ? 0 : sectionSize,
          maxWidth: theme.sizes.container[1],
          px: ['0', '0'],
          ...styles,
        }}
      >
        <SlickSlider
          slidesToShow={slidesToShow}
          slidesToScroll={slidesToScroll}
          dots={showDots}
          infinite={infinite}
          adaptiveHeight
          lazyLoad="progressive"
          centerMode
          arrows={showArrows}
        >
          {children}
        </SlickSlider>
      </Box>
    </Box>
  );
};

export default Slider;
